// Import necessary modules from React
import React, { useEffect} from "react";
// Import useNavigate and useParams hooks from react-router-dom
import { useParams } from "react-router-dom";
// Import custom hooks and components
import DiagramacaoPreview from "../../../LayoutsExamsView/form/components/DiagramacaoPreview/DiagramacaoPreview";
// Import the useTests hook to fetch test data
import useDiagramacaoForm from "../../../LayoutsExamsView/form/hooks/useDiagramacaoForm";
import { useTests } from "../../../../hooks/test/useTests";
import { TestDetails } from "../../../../hooks/test/types/types";


export function DissertationPrinted() {
  //* Get the token from local storage
  const token = localStorage.getItem("token") || "";
  //* Get the parameters from the URL
  const {
    testId,
    diagramId,
    answerSheetId,
    registrationId,
    studentId,
  } = useParams<{
    testId?: string;
    diagramId?: string;
    answerSheetId?: string;
    registrationId?: string;
    studentId?: string;
    edit?: string;
    urltoken?: string;
  }>();

  //* Hook to navigate between pages
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { test: provas, loading: loadingTests, getTestById } = useTests(token);


  // Hook de diagramação
  const {
    loading,
    setLoading,
    msgErro,
    setMsgErro,
    provaSelect,
    setProvaSelect,
    nomeProva,
    setNomeProva,
    numeroColunas,
    setNumeroColunas,
    fontSizeQuestoes,
    setFontSizeQuestoes,
    marginSuperior,
    setMarginSuperior,
    marginInferior,
    setMarginInferior,
    marginEsquerda,
    setMarginEsquerda,
    marginDireita,
    setMarginDireita,
    questionPages,
    setQuestionPages,
    handleSave,
    // Campos básicos
    nickNameLayout,
    setNickNameLayout,
    title,
    setTitle,
    subtitle,
    setSubtitle,
    titleHeader,
    setTitleHeader,
    subtitleHeader,
    setSubtitleHeader,
    // Logos
    logo,
    setLogo,
    logoBottom,
    setLogoBottom,
    // Configurações de fonte
    fontSizeRules,
    setFontSizeRules,
    fontSizeAlternatives,
    setFontSizeAlternatives,
    // Configurações de layout
    numberColumnsRules,
    setNumberColumnsRules,
    showDiscipline,
    setShowDiscipline,
    borderVisible,
    setBorderVisible,
    // Configurações de randomização
    randomQuestion,
    setRandomQuestion,
    randomAlternatives,
    setRandomAlternatives,
    randomPerCategory,
    setRandomPerCategory,
    selectFromGroup,
    setSelectFromGroup,
    numberSelectQuestions,
    setNumberSelectQuestions,
    // Configurações da folha de resposta
    titleAnswer,
    setTitleAnswer,
    subtitleAnswer,
    setSubtitleAnswer,
    nameAnswer,
    setNameAnswer,
    answerPageVisible,
    setAnswerPageVisible,
    rules,
    setRules,
    rulesAnswer,
    setRulesAnswer,
    // Configurações de layout padrão
    defaultLayout,
    setDefaultLayout,
    nameDefault,
    setNameDefault,
    //elementos
    dataFrontPage,
    setDataFrontPage,
  } = useDiagramacaoForm({ token, printMode: true, id: diagramId });

   // Atualiza os elementos do DataFrontPage conforme valores mudam
    useEffect(() => {
      setDataFrontPage((prevData) =>
        prevData.map((item) => {
          const originalHtml = item.element;
          let replaced = originalHtml;
          replaced = replaced.replace(/:title/g, title || "");
          replaced = replaced.replace(/:subtitle/g, subtitle || "");
          replaced = replaced.replace(/:header_title/g, titleHeader || "");
          replaced = replaced.replace(/:header_subtitle/g, subtitleHeader || "");
  
          if (replaced.includes("%LOGO%")) {
            replaced = replaced.replace(
              /%LOGO%/g,
              typeof logo === "string" ? logo : ""
            );
          }
          if (replaced.includes("%LOGO_BOTTOM%")) {
            replaced = replaced.replace(
              /%LOGO_BOTTOM%/g,
              typeof logoBottom === "string" ? logoBottom : ""
            );
          }
          replaced = replaced.replace(/:nome_cargo/g, nomeProva || "");
          replaced = replaced.replace(/:nome_seletivo/g, title || "");
          replaced = replaced.replace(
            /:nome_prova/g,
            nomeProva || "Nome da prova"
          );
  
          return {
            ...item,
            element: replaced,
            baseElement:item.element,
          };
        })
      );
    }, [
      title,
      subtitle,
      titleHeader,
      subtitleHeader,
      logo,
      logoBottom,
      nomeProva,
      setDataFrontPage,
    ]);

  return (
    <div>
      <DiagramacaoPreview
        provas={provas}
        provaSelect={provaSelect}
        questionPages={questionPages}
        setQuestionPages={setQuestionPages}
        setProvaSelect={
          setProvaSelect as React.Dispatch<
            React.SetStateAction<TestDetails | null>
          >
        }
        nomeProva={nomeProva}
        setNomeProva={setNomeProva}
        numeroColunas={numeroColunas}
        setNumeroColunas={setNumeroColunas}
        fontSizeQuestoes={
          fontSizeQuestoes === "default" ? 12 : fontSizeQuestoes
        }
        setFontSizeQuestoes={setFontSizeQuestoes}
        marginSuperior={marginSuperior}
        setMarginSuperior={setMarginSuperior}
        marginInferior={marginInferior}
        setMarginInferior={setMarginInferior}
        marginEsquerda={marginEsquerda}
        setMarginEsquerda={setMarginEsquerda}
        marginDireita={marginDireita}
        setMarginDireita={setMarginDireita}
        handleSave={handleSave}
        loading={loading}
        setLoading={setLoading}
        msgErro={msgErro}
        setMsgErro={setMsgErro}
        getTestById={getTestById}
        // Novos campos
        nickNameLayout={nickNameLayout}
        setNickNameLayout={setNickNameLayout}
        title={title}
        setTitle={setTitle}
        subtitle={subtitle}
        setSubtitle={setSubtitle}
        titleHeader={titleHeader}
        setTitleHeader={setTitleHeader}
        subtitleHeader={subtitleHeader}
        setSubtitleHeader={setSubtitleHeader}
        logo={logo}
        setLogo={setLogo}
        logoBottom={logoBottom}
        setLogoBottom={setLogoBottom}
        fontSizeRules={fontSizeRules}
        setFontSizeRules={setFontSizeRules}
        fontSizeAlternatives={fontSizeAlternatives}
        setFontSizeAlternatives={setFontSizeAlternatives}
        numberColumnsRules={numberColumnsRules}
        setNumberColumnsRules={setNumberColumnsRules}
        showDiscipline={showDiscipline}
        setShowDiscipline={setShowDiscipline}
        borderVisible={borderVisible}
        setBorderVisible={setBorderVisible}
        randomQuestion={randomQuestion}
        setRandomQuestion={setRandomQuestion}
        randomAlternatives={randomAlternatives}
        setRandomAlternatives={setRandomAlternatives}
        randomPerCategory={randomPerCategory}
        setRandomPerCategory={setRandomPerCategory}
        selectFromGroup={selectFromGroup}
        setSelectFromGroup={setSelectFromGroup}
        numberSelectQuestions={numberSelectQuestions}
        setNumberSelectQuestions={setNumberSelectQuestions}
        titleAnswer={titleAnswer}
        setTitleAnswer={setTitleAnswer}
        subtitleAnswer={subtitleAnswer}
        setSubtitleAnswer={setSubtitleAnswer}
        nameAnswer={nameAnswer}
        setNameAnswer={setNameAnswer}
        answerPageVisible={answerPageVisible}
        setAnswerPageVisible={setAnswerPageVisible}
        rules={rules}
        setRules={setRules}
        rulesAnswer={rulesAnswer}
        setRulesAnswer={setRulesAnswer}
        defaultLayout={defaultLayout}
        setDefaultLayout={setDefaultLayout}
        nameDefault={nameDefault}
        setNameDefault={setNameDefault}
        DataFrontPage={dataFrontPage}
        setDataFrontPage={setDataFrontPage}
        printMode={true}
        editMode={true}
        testId={testId}
        diagramId={diagramId}
        answerSheetId={answerSheetId}
        registrationId={registrationId}
        studentId={studentId}
      />
    </div>
  );
};

export default DissertationPrinted;
